<template>
    <v-layout align-start>
        <v-layout column class="subheading mx-4 my-3">
            <div class="text-h6">Customer Information</div>
            <v-layout class="mt-3 mb-2">
                <v-flex xs3>Name:</v-flex>
                <v-flex>{{ info.first_name }} {{ info.last_name }}</v-flex>
            </v-layout>
            <v-layout class="mb-2">
                <v-flex xs3>Email:</v-flex>
                <v-flex>{{ info.email }}</v-flex>
            </v-layout>
            <v-layout class="mb-2">
                <v-flex xs3>Phone:</v-flex>
                <v-flex>{{ info.phone_number }}</v-flex>
            </v-layout>
            <v-layout class="mb-2">
                <v-flex xs3>Reservation Type:</v-flex>
                <v-flex>
                    <span v-if="options.reservationType === 'reservation'">Reservation</span>
                    <span v-if="options.reservationType === 'inquiry'">Lead</span>
                </v-flex>
            </v-layout>
            <v-layout class="mb-2">
                <v-flex xs3>Move In Date:</v-flex>
                <v-flex>{{ formatDate(options.moveInDate) }}</v-flex>
            </v-layout>
            <v-layout class="mb-2">
                <v-flex xs3>Follow Up Date:</v-flex>
                <v-flex>{{ formatDate(options.followupDate) }}</v-flex>
            </v-layout>
            <v-flex class="mt-5 mb-4 subheading" v-if="currentStep == 2">
                <v-btn
                  data-testid="reservation-return-to-options-btn"
                  class="reservation-return-to-options-btn"
                  @click="toOptions"
                >
                    <v-icon class="mr-3">shopping_cart</v-icon>
                    Return to Reservation Options
                </v-btn>
            </v-flex>
        </v-layout>
        <v-layout column class="subheading mx-4 my-3">
            <div class="text-h6">Unit Details</div>
            <v-layout class="mt-3 mb-2">
                <v-flex xs3>Size:</v-flex>
                <v-flex>'{{ reservedUnit.width }} x '{{ reservedUnit.length }}</v-flex>
            </v-layout>
            <v-layout class="mb-2">
                <v-flex xs3>Unit Type:</v-flex>
                <v-flex>{{ reservedUnit.type_name }}</v-flex>
            </v-layout>
            <v-layout class="mb-2">
                <v-flex xs3>Rate:</v-flex>
                <v-flex>${{ reservedUnit.rate }}/month</v-flex>
            </v-layout>
            <v-layout class="mb-2">
                <v-flex xs3>Promotion Offered:</v-flex>
                <v-flex>
                    <span v-if="reservedUnit.promotion_text">{{ reservedUnit.promotion_text }}</span>
                    <span v-else>No Promotion</span>
                </v-flex>
            </v-layout>
            <v-layout class="mb-2">
                <v-flex xs3>Features:</v-flex>
                <v-flex>
                    <div v-for="(feature, i) in reservedUnit.features" :key="i">
                        {{ feature }}
                    </div>
                </v-flex>
            </v-layout>
        </v-layout>
    </v-layout>
</template>

<script>
import { dateMethodMixins } from "@/mixins/dateMethodMixins";
import { mapState } from "vuex";

export default {
  mixins: [dateMethodMixins],

  props: [
    "currentStep",
    "reservedUnit"
  ],

  methods: {
    toOptions() {
      this.$emit("toOptions");
    }
  },

  computed: {
    ...mapState({
      info: state => state.tenant.info,
      options: state => state.tenant.options
    })
  }
};
</script>
